import store from '@/store';

const AdminAgreementList = () => import(/* webpackChunkName: "admin-module" */ '@/views/admin/agreements/views/AdminAgreementList.vue');
const AdminAgreementEdit = () => import(/* webpackChunkName: "admin-module" */ '@/views/admin/agreements/views/AdminAgreementEdit.vue');

export default [
    {
        path: 'admin/agreements',
        name: 'admin.agreements',
        components: { base: AdminAgreementList },
        beforeEnter: (to, from, next) => {
            if (store.getters.canAccessAdminAgreementsIndex) {
                next();
            } else {
                next({ path: '/access-restricted' });
            }
        }
    },
    {
        path: 'admin/agreements/:agreement_id',
        name: 'admin.agreements.edit',
        components: { base: AdminAgreementEdit },
        beforeEnter: (to, from, next) => {
            if (store.getters.canAccessAdminAgreementsIndex) {
                next();
            } else {
                next({ path: '/access-restricted' });
            }
        }
    }
];
